import { getDevicesHash } from '../selectors';
import { calculateDevicesHash, getEnumerateDevices } from '../helpers';
import { checkCurrentDevices } from './current-devices';
export const updateDevices = () => async (dispatch, getState) => {
    const prevDevicesHash = getDevicesHash(getState());
    const devices = await getEnumerateDevices();
    const devicesHash = calculateDevicesHash(devices);
    // dispatch only when devices changed, kept from old implementation,
    // is it correct to compare like this?
    if (prevDevicesHash !== devicesHash) {
        dispatch(setDevices(devices));
    }
};
const setDevices = (devices) => (dispatch) => {
    dispatch({ type: 'DEVICES/SET_DEVICES', payload: devices });
    dispatch(checkCurrentDevices());
};
export const setCameraAccess = (hasAccess) => (dispatch) => {
    dispatch({ type: 'DEVICES/SET_CAMERA_ACCESS', payload: hasAccess });
};
export const setMicrophoneAccess = (hasAccess) => (dispatch) => {
    dispatch({ type: 'DEVICES/SET_MICROPHONE_ACCESS', payload: hasAccess });
};
